import React from 'react';

export default function QualifyingFinal() {
  return <>Qualifying Final</>;
}
